// Client lib imports
const airbrake = require('client/lib/airbrake')
const businessEvents = require('client/lib/business-events')
const { send: ajax } = require('client/lib/request')
// Common Client v2 imports
const clientV1Bridge = require('client-v2/common/client-v1-bridge')
const { navigate } = require('client-v2/common/state/router/actions')

// Action enums

const USER_FOLLOWING_CHANGE_PENDING = 'USER_FOLLOWING_CHANGE_PENDING'

// Action types

const USER_FOLLOWING_CHANGE = 'USER_FOLLOWING_CHANGE'

// Action creators

function userFollowingChange(userId, isFollowing) {
  return {
    type: USER_FOLLOWING_CHANGE,
    payload: {
      userId,
      isFollowing
    }
  }
}

function userFollowingChangePending(userId) {
  return userFollowingChange(
    userId,
    USER_FOLLOWING_CHANGE_PENDING
  )
}

// Action dispatchers


function showUserActionsModal({ user, pageContext }) {
  // Mitigate circular dependency
  const clientV1Bridge = require('client-v2/common/client-v1-bridge')
  return function (dispatch, getState) {
    clientV1Bridge.showUserActionsModal({
      reportedUser: user,
      reporterUser: getState().user,
      pageContext
    })
  }
}

function showUserShareModal({ user }) {
  // Mitigate circular dependency
  const clientV1Bridge = require('client-v2/common/client-v1-bridge')
  return function () {
    clientV1Bridge.showUserShareModal({ shareUser: user })
  }
}

function toggleFollowing({ user, pageContext }) {
  return async function (dispatch) {
    const toggledFollowing = !user.isFollowing
    const method = toggledFollowing ? 'post' : 'delete'
    // Set front-end following state to "pending"
    dispatch(userFollowingChangePending(user.id))
    try {
      // Update following state on back-end
      await ajax({
        url: `/api/v0.1/friends/${user.id}`,
        method
      })
    } catch (err) {
      airbrake.notify(err)
      // Revert the front-end following state
      dispatch(userFollowingChange(user.id, user.isFollowing))
      // Inform the user that their action was unsuccessful
      clientV1Bridge.showAlertModal({
        heading: `Friend status could not be updated.`,
        subheading: `Something went wrong on our end. Please try again.`
      })
      return
    }
    // Update the front-end to reflect the successful action
    dispatch(userFollowingChange(user.id, toggledFollowing))
    // Send tracking call
    const action = toggledFollowing ? 'follow' : 'unfollow'
    await businessEvents.trackSegment(`${action}-person`, {
      'user_id': user.id
    }, {
      pageContext
    })
  }
}

// Helpers

function navigateToUserHref(hrefFunc) {
  // Creates a navigation action dispatcher from a href helper function
  return function ({ event, pageContext, user }) {
    return function (dispatch) {
      dispatch(navigate({
        event,
        pageContext,
        href: hrefFunc(user)
      }))
    }
  }
}

function userProfileHref(user) {
  return `/${user.username}`
}

function userProfileCollectionsHref(user) {
  return `${userProfileHref(user)}/collections`
}

function userProfileCollectionsCreatedHref(user) {
  return `${userProfileCollectionsHref(user)}/created`
}

function userProfileCollectionsSubscribedHref(user) {
  return `${userProfileCollectionsHref(user)}/subscribed`
}

function userProfilePostsHref(user) {
  return `${userProfileHref(user)}/posts`
}

function userProfileFollowersHref(user) {
  return `${userProfileHref(user)}/followers`
}

function userProfileFollowingHref(user) {
  return `${userProfileHref(user)}/following`
}

module.exports = {
  // Enums
  USER_FOLLOWING_CHANGE_PENDING,
  // Types
  USER_FOLLOWING_CHANGE,
  // Dispatchers
  showUserActionsModal,
  showUserShareModal,
  toggleFollowing,
  // Helpers
  userProfileHref,
  userProfileCollectionsHref,
  userProfileCollectionsCreatedHref,
  userProfileCollectionsSubscribedHref,
  userProfileFollowersHref,
  userProfileFollowingHref,
  userProfilePostsHref
}

// Define navigation dispatchers
Object.entries({
  navigateToUserProfile: userProfileHref,
  navigateToUserProfileCollections: userProfileCollectionsHref,
  navigateToUserProfileCollectionsCreated: userProfileCollectionsCreatedHref,
  navigateToUserProfileCollectionsSubscribed: userProfileCollectionsSubscribedHref,
  navigateToUserProfileFollowers: userProfileFollowersHref,
  navigateToUserProfileFollowing: userProfileFollowingHref,
  navigateToUserProfilePosts: userProfilePostsHref
}).forEach(([ key, value ]) => {
  module.exports[key] = navigateToUserHref(value)
})
